
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 417 76","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.56 31.63c-4.156-9.576 2.863-20.273 13.301-20.273H61c8.008 0 14.5 6.492 14.5 14.5V61c0 8.008-6.492 14.5-14.5 14.5H22.532c-10.355 0-17.373-10.541-13.378-20.094l2.715-6.492a15.5 15.5 0 00-.081-12.15l-2.229-5.135zM406.631 55.228c4.155 9.575-2.863 20.272-13.302 20.272H355.19c-8.008 0-14.5-6.492-14.5-14.5V25.857c0-8.008 6.492-14.5 14.5-14.5h38.469c10.355 0 17.372 10.541 13.377 20.094l-2.714 6.492a15.497 15.497 0 00.081 12.15l2.228 5.135z","fill":"#8DEBFF","stroke":"#009ACB"}}),_c('rect',{attrs:{"x":"57.199","y":".5","width":"300.587","height":"64.143","rx":"14.5","fill":"#8DEBFF","stroke":"#009ACB"}})])
          )
        }
      }
    